import { render, staticRenderFns } from "./product-log.vue?vue&type=template&id=55a7ff15&scoped=true&"
import script from "./product-log.vue?vue&type=script&lang=js&"
export * from "./product-log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a7ff15",
  null
  
)

export default component.exports